module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2011 by Martin Edwards")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Edition 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Catalog Card Number: 2010932107")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN: 9781590588529 Hardcover")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN: 9781590588543 Trade Paperback")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 9781615952694 epub")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior written permission of both the copyright owner and the publisher of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The historical characters and events portrayed in this book are inventions of the author or used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Poisoned Pen Press"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("6962 E. First Ave., Ste. 103"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("Scottsdale, AZ 85251")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("www.poisonedpenpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("info@poisonedpenpress.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ae2954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/The_Hanging_Wood-1.vue
// module id = 63
// module chunks = 0